import React from 'react';
import { Box, Paper, Typography, Button, Alert } from '@mui/material';

class SectionErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (typeof window !== 'undefined' && window.console) {
      window.console.error('[MyPages] Error in section', error, info);
    }
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <Box sx={{ p: 4 }}>
          <Paper sx={{ p: 4, maxWidth: 720, mx: 'auto' }}>
            <Alert severity="error" sx={{ mb: 2 }}>
              Något gick fel när vyn laddades.
            </Alert>
            {error?.message && (
              <Typography variant="body2" sx={{ mb: 2, fontFamily: 'monospace' }}>
                {error.message}
              </Typography>
            )}
            <Button variant="contained" onClick={this.handleReload}>
              Försök igen
            </Button>
          </Paper>
        </Box>
      );
    }
    return children;
  }
}

export default SectionErrorBoundary;
